import { Component, computed, inject, input, output, resource } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthService } from '../../../auth/keycloak.service';
import { PermisosService } from '../../../auth/permisos.service';
import { version } from '../../../../../../../package.json';

interface MenuItem {
  route: string;
  icon: string;
  label: string;
  roles: string[];
}

@Component({
  selector: 'app-sidebar',
  imports: [RouterModule],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.css',
})
export class Sidebar {
  authService = inject(AuthService);
  private permisos = inject(PermisosService);
  readonly appVersion = version;

  open = input<boolean>(false);
  closeRequest = output<void>();

  private allMenuItems: MenuItem[] = [
    { route: '/dashboard',    icon: 'fas fa-home',             label: 'Panel de control',   roles: ['admin', 'deposito', 'planta'] },
    { route: '/material',     icon: 'fas fa-boxes',            label: 'Stock de Materiales', roles: ['admin', 'deposito', 'planta'] },
    { route: '/equipo',       icon: 'fas fa-tools',            label: 'Equipos',             roles: ['admin', 'deposito', 'planta'] },
    { route: '/pedido',       icon: 'fas fa-clipboard-list',   label: 'Pedidos',             roles: ['admin', 'deposito', 'planta'] },
    { route: '/orden-retiro', icon: 'fas fa-dolly',            label: 'Órdenes de Retiro',  roles: ['admin', 'deposito', 'planta', 'operario'] },
  ];

  menuItems = computed(() => {
    const esAdmin    = this.permisos.esAdmin;
    const esDeposito = this.permisos.esDeposito;
    const esPlanta   = this.permisos.esPlanta;
    const esOperario = this.permisos.esOperario;

    return this.allMenuItems.filter((item) =>
      item.roles.some((role) => {
        if (role === 'admin')    return esAdmin;
        if (role === 'deposito') return esDeposito;
        if (role === 'planta')   return esPlanta;
        if (role === 'operario') return esOperario;
        return false;
      })
    );
  });

  usuarioResource = resource({
    loader: () => this.authService.getUsuarioNombre()
  });

  logout() {
    if (confirm('¿Estás seguro que deseas cerrar sesión en el sistema de inventario?')) {
      this.authService.logout();
    }
  }
}
